import type { LogoProfile } from '../types/index.js'
import { NO_LOGO_VALUE } from './utils.js'

type Profile = Pick<LogoProfile, 'id' | 'key' | 'active'>
interface ProgramLogoState {
  logoProfileId: string
  isLive: boolean
  isNew: boolean
}

/** Sélection automatique propre aux fiches programme, pas aux séries. */
export function programLogoProfileId(profiles: readonly Profile[], state: ProgramLogoState, flagsChanged = false): string {
  if (state.logoProfileId === NO_LOGO_VALUE) return NO_LOGO_VALUE
  const active = profiles.filter(profile => profile.active)
  const current = active.find(profile => profile.id === state.logoProfileId)
  if (!flagsChanged && !state.isLive && !state.isNew && current && !['normal', 'direct', 'inedit'].includes(current.key)) return current.id
  const key = state.isLive ? 'direct' : state.isNew ? 'inedit' : 'normal'
  return (active.find(profile => profile.key === key) ?? active.find(profile => profile.key === 'normal'))?.id ?? ''
}
